"use client"

import { t } from "@/languages/i18n"
import type { AlbumLayout } from "@/stores/use-album-modal-store"

export interface LayoutOption {
  id: AlbumLayout
  label: string
  desc: string
  preview: React.ReactNode
}

export const GRID_COLORS = ["#c7d2fe", "#fbcfe8", "#a7f3d0", "#fde68a", "#e9d5ff", "#fed7aa"]

export function getLayoutOptions(): LayoutOption[] {
  return [
    {
      id: "grid",
      label: t("Grid"),
      desc: t("Images arranged evenly in rows and columns"),
      preview: (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 3, padding: 6 }}>
          {GRID_COLORS.map((c, i) => (
            <div key={i} style={{ aspectRatio: "1", background: c, borderRadius: 3 }} />
          ))}
        </div>
      ),
    },
    {
      id: "masonry",
      label: t("Masonry"),
      desc: t("Alternating height images Pinterest style"),
      preview: (
        <div style={{ display: "flex", flexDirection: "column", gap: 3, padding: 6 }}>
          <div style={{ display: "flex", gap: 3, alignItems: "flex-start" }}>
            <div style={{ width: "62%", aspectRatio: "3/4", background: "#c7d2fe", borderRadius: 3 }} />
            <div style={{ width: "36%", aspectRatio: "3/5", background: "#fbcfe8", borderRadius: 3 }} />
          </div>
          <div style={{ display: "flex", gap: 3, alignItems: "flex-end" }}>
            <div style={{ width: "36%", aspectRatio: "4/3", background: "#a7f3d0", borderRadius: 3 }} />
            <div style={{ width: "62%", aspectRatio: "4/5", background: "#fde68a", borderRadius: 3 }} />
          </div>
        </div>
      ),
    },
    {
      id: "slider",
      label: t("Slider"),
      desc: t("Album slideshow with navigation buttons"),
      preview: (
        <div style={{ position: "relative", borderRadius: 6, overflow: "hidden", border: "1px dashed #d9d9d9", aspectRatio: "16/9", display: "flex", alignItems: "center", justifyContent: "center", padding: 6 }}>
          <button style={{ position: "absolute", left: 6, top: "50%", transform: "translateY(-50%)", background: "rgba(0,0,0,0.3)", color: "#fff", border: "none", borderRadius: "50%", width: 24, height: 24, cursor: "pointer", fontSize: 12, display: "flex", alignItems: "center", justifyContent: "center" }}>‹</button>
          <button style={{ position: "absolute", right: 6, top: "50%", transform: "translateY(-50%)", background: "rgba(0,0,0,0.3)", color: "#fff", border: "none", borderRadius: "50%", width: 24, height: 24, cursor: "pointer", fontSize: 12, display: "flex", alignItems: "center", justifyContent: "center" }}>›</button>
          <div style={{ position: "absolute", bottom: 6, left: "50%", transform: "translateX(-50%)", display: "flex", gap: 4 }}>
            {["#1677ff", "#d9d9d9", "#d9d9d9"].map((c, i) => (
              <div key={i} style={{ width: 6, height: 6, borderRadius: "50%", background: c }} />
            ))}
          </div>
        </div>
      ),
    },
  ]
}
